import app from './app';
import auth from './auth';
import cartContext from './cart-context';
import errors from './errors';
import notifications from './notifications';
import settings from './settings';

export default {
  app,
  auth,
  cartContext,
  errors,
  notifications,
  settings,
}
